import { Component, Input } from '@angular/core';
import Employee from 'src/app/model/product/employee';

@Component({
  selector: 'employee-tour-list',
  templateUrl: './employee-tour-list.component.html',
  styleUrls: ['./employee-tour-list.component.scss']
})
export class EmployeeTourListComponent {
  @Input()
  placers: Employee[];
}
